var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480 96H376C362.75 96 352 106.75 352 120S362.75 144 376 144H480C541.75 144 592 194.25 592 256S541.75 368 480 368H376C362.75 368 352 378.75 352 392S362.75 416 376 416H480C568.219 416 640 344.219 640 256S568.219 96 480 96ZM264 368H160C98.25 368 48 317.75 48 256S98.25 144 160 144H264C277.25 144 288 133.25 288 120S277.25 96 264 96H160C71.781 96 0 167.781 0 256S71.781 416 160 416H264C277.25 416 288 405.25 288 392S277.25 368 264 368ZM192 256C192 269.25 202.75 280 216 280H424C437.25 280 448 269.25 448 256S437.25 232 424 232H216C202.75 232 192 242.75 192 256Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkSimple);
export default __webpack_public_path__ + "static/media/link-simple.dcbcfb7ad168a0fb3f6a7489c7b56ead.svg";
export { ForwardRef as ReactComponent };